import axios from 'axios';
import { Auth } from 'aws-amplify';
import { buildApiUrl } from './apiConfig';
import { ApiEnvelope, getApiErrorMessage, unwrapApiData } from './apiResponse';

export interface FeedbackContent {
  strengths: string[];
  areas_to_improve: string[];
  next_step: string;
  review_flags?: string[];
}

export interface FeedbackItem {
  feedback_id: string;
  question: string;
  student_answer: string;
  module_id: string;
  unit_id: string;
  set_id: string;
  question_id: string;
  created_at: string;
  status: 'queued' | 'processing' | 'ready' | 'failed';
  publication_status: 'awaiting_review' | 'published' | 'rejected';
  feedback?: FeedbackContent;
  published_at?: string;
  student_id?: string;
  module_title?: string;
  revision?: number;
  generation?: number;
  model_id?: string;
  input?: {
    question: string;
    student_answer: string;
    rubric: string;
    reference_answer: string;
    grade_level: string;
    subject: string;
  };
  draft?: FeedbackContent;
  edited?: FeedbackContent;
}

async function headers() {
  const session = await Auth.currentSession();
  return { Authorization: `Bearer ${session.getIdToken().getJwtToken()}` };
}

export async function listFeedback(
  cursor?: string,
): Promise<{ items: FeedbackItem[]; cursor: string | null }> {
  try {
    const response = await axios.get<ApiEnvelope<{ items: FeedbackItem[]; cursor: string | null }>>(
      buildApiUrl('feedback', 'v2'),
      { headers: await headers(), params: cursor ? { cursor } : {} },
    );
    return unwrapApiData(response.data, 'Could not load feedback');
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Could not load feedback'));
  }
}

export async function reviewFeedback(
  item: FeedbackItem,
  action: 'save' | 'publish' | 'reject' | 'regenerate',
  feedback?: FeedbackContent,
) {
  try {
    const response = await axios.put<ApiEnvelope<{ item: FeedbackItem }>>(
      buildApiUrl(`feedback/${encodeURIComponent(item.feedback_id)}`, 'v2'),
      {
        action,
        revision: item.revision,
        ...(feedback
          ? { feedback: { ...feedback, review_flags: feedback.review_flags || [] } }
          : {}),
      },
      { headers: await headers() },
    );
    return unwrapApiData(response.data, 'Could not update feedback').item;
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Could not update feedback'));
  }
}
